import { NOT_FOUND } from 'redux-first-router';
import * as types from './../actions/actionTypes';

export default (state = 'Home', action = {}) => {
    const lang = (
        action.payload || {}
    ).language || 'de';

    switch (action.type) {

        case types.NAVIGATED_TO_IMPRINT:
            return `${lang}Imprint`;

        case types.NAVIGATED_TO_PRIVACY:
            return `${lang}Privacy`;

        case types.NAVIGATED_TO_TOS:
            return `${lang}Tos`;

        case types.NAVIGATED_TO_CONTACT:
            return `${lang}Contact`;

        case types.NAVIGATED_TO_FAQ_RECOLORING:
            return `${lang}faq-coloring-options`;

        case types.NAVIGATED_TO_FAQ_SHIPPING:
            return `${lang}Shipping`;

        default:
            return components[action.type] || state;
    }
};

const components = {

    [types.NAVIGATED_TO_HOME]: 'Home',
    [types.NAVIGATED_TO_ABOUT]: 'Home',
    [types.NAVIGATED_TO_HASHTAG]: 'Hashtag',

    [types.NAVIGATED_TO_TOPCATEGORIES]: 'TopCategoriesGalleries',
    [types.NAVIGATED_TO_SUBCATEGORIES]: 'SubCategoryGallery',

    [types.NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY]: 'CategoryPatterns',

    [types.NAVIGATED_TO_NEWSLETTER_FORM]: 'NewsletterForm',

    [types.NAVIGATED_TO_SINGLE_PATTERN_VIEW]: 'SinglePatternView',

    [types.NAVIGATED_TO_SEWPAT_VIEW]: 'SingleSewpatView',

    [types.NAVIGATED_TO_SEWPAT_GALLERY]: 'SewpatGallery',
    [types.NAVIGATED_TO_SEWPAT_PATTERN_GALLERY]: 'CategoriesOverview',

    [NOT_FOUND]: 'NotFound',

    [types.NAVIGATED_TO_SEARCHGALLERY]: 'SearchResult',
    [types.NAVIGATED_TO_LOVED_PATTERNS]: 'FavoritesGallery',
    [types.NAVIGATED_TO_NEWEST_PATTERNGALLERY]: 'PatterngalleryNewest',
    [types.NAVIGATED_TO_DEFAULT_NEWEST_PATTERNGALLERY]: 'PatterngalleryNewest',
    [types.NAVIGATED_TO_PATTERNS_FROM_DESIGNER]: 'DesignerGallery',

    [types.NAVIGATED_TO_FAQ_FABRICS]: 'Fabrics',
    [types.NAVIGATED_TO_FAQ_SEWPATS]: 'sewpats',

    [types.NAVIGATED_TO_COLORSWATCHES_CART_FORM]: 'ColorSwatchesCartForm',

};

export const getPage = state => state.page;

export const isLandingPage = state => {
    const page = getPage(state);
    const landingPages = [
        'Home',
        'SingleSewpatView',
        'SewpatGalleries',
        'CategoryPatterns',
        'CategoriesOverview',
        'SinglePatternView',
        'SewpatGallery',
        'PatterngalleryNewest',
        'FavoritesGallery',
        'SearchResult',
    ];
    return landingPages.indexOf(page) > -1;
};

export const isHomePage = state => getPage(state) === 'Home';

export const getCurrentPageNumber = state => parseInt((
    state.location.query || {}
).page, 10) || 1;

export const getCurrentUri = state => {
    let uri = `https://www.schnoffle.de${state.location.pathname}`;
    if (state.location.search) {
        uri = `${uri}?${state.location.search}`;
    }
    return uri;
};

export const getCurrentBaseUri = state => {
    let uri = 'https://www.schnoffle.de';
    if (state.location.payload && state.location.payload.language) {
        uri = `${uri + state.location.payload.language}/`;
    }
    return uri;
};

export const getCurrentQueryObject = state => {
    if (state.location.query) {
        return state.location.query;
    }
};

export const getCurrentSearchString = state => {
    if (state.location.search && state.location.search.length > 0) {
        return state.location.search;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/page.js